// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__vsEf5","copyright":"Footer_copyright__qtmxm"};